import INotificationsContext from "./INotificationsContext";

const initialState: Pick<INotificationsContext, "notifications"> = {
  notifications: [],
};

export default initialState;
